module.exports = __webpack_public_path__ + "img/blue_176.65cf1398.png";